// Check for runtime config first, then fallback to build-time env vars
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      VITE_API_BASE_URL?: string;
      VITE_CENTRAL_AUTH_URL?: string;
      VITE_CENTRAL_AUTH_API_URL?: string;
      VITE_MCP_SERVER_URL?: string;
      VITE_SIDEBAR_API_URL?: string;
    };
  }
}

export const config = {
  instanceUrl:
    (typeof window !== "undefined" &&
    window.__RUNTIME_CONFIG__?.VITE_API_BASE_URL &&
    window.__RUNTIME_CONFIG__?.VITE_API_BASE_URL !== "${VITE_API_BASE_URL}"
      ? window.__RUNTIME_CONFIG__?.VITE_API_BASE_URL
      : import.meta.env.VITE_API_BASE_URL) || "https://localhost:7136",

  centralAuthUrl:
    (typeof window !== "undefined" &&
    window.__RUNTIME_CONFIG__?.VITE_CENTRAL_AUTH_URL &&
    window.__RUNTIME_CONFIG__?.VITE_CENTRAL_AUTH_URL !==
      "${VITE_CENTRAL_AUTH_URL}"
      ? window.__RUNTIME_CONFIG__?.VITE_CENTRAL_AUTH_URL
      : import.meta.env.VITE_CENTRAL_AUTH_URL) || "https://my.anythink.cloud",

  centralAuthApiUrl:
    (typeof window !== "undefined" &&
    window.__RUNTIME_CONFIG__?.VITE_CENTRAL_AUTH_API_URL &&
    window.__RUNTIME_CONFIG__?.VITE_CENTRAL_AUTH_API_URL !==
      "${VITE_CENTRAL_AUTH_API_URL}"
      ? window.__RUNTIME_CONFIG__?.VITE_CENTRAL_AUTH_API_URL
      : import.meta.env.VITE_CENTRAL_AUTH_API_URL) ||
    "https://api.my.anythink.cloud",

  mcpServerUrl:
    (typeof window !== "undefined" &&
    window.__RUNTIME_CONFIG__?.VITE_MCP_SERVER_URL &&
    window.__RUNTIME_CONFIG__?.VITE_MCP_SERVER_URL !== "${VITE_MCP_SERVER_URL}"
      ? window.__RUNTIME_CONFIG__?.VITE_MCP_SERVER_URL
      : import.meta.env.VITE_MCP_SERVER_URL) || "http://localhost:5299",

  sidebarApiUrl:
    (typeof window !== "undefined" &&
    window.__RUNTIME_CONFIG__?.VITE_SIDEBAR_API_URL &&
    window.__RUNTIME_CONFIG__?.VITE_SIDEBAR_API_URL !==
      "${VITE_SIDEBAR_API_URL}"
      ? window.__RUNTIME_CONFIG__?.VITE_SIDEBAR_API_URL
      : import.meta.env.VITE_SIDEBAR_API_URL) || "",
};
